// The Vue build version to load with the `import` command;
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import jquery from 'jquery';
import 'babel-polyfill';
import Vue from "vue";
import "print-js";
import App from "./App";
import router from "./router";
import $download from "./$download";

import Loading from "vue-loading-overlay";
import Notifications from "vue-notification";

// clipboard
import VueClipboard from 'vue-clipboard2';

// tooltip
import VTooltip from "v-tooltip";

// select
import Select2 from "v-select2-component";

import "vue-loading-overlay/dist/vue-loading.css";

import VueAxios from "vue-axios";
import axiosInstance from "./$axios";

import NProgress from 'nprogress';
import '../node_modules/nprogress/nprogress.css';

// script to encrypt tokens
import {encrypt, decrypt} from './encrypt';
import {ClientTable, Event} from 'vue-tables-2';

// import VueProgressBar from 'vue-progressbar';

// Custom made functions
import {
  loader
} from "./loader";
import store from "./store";
import {
  number
} from "./number";
import {
  currency
} from "./currency";
import {
  copyClip
} from "./modal-copy";
import applyTable from "./applyTable";
import {paginateTable} from "./paginator";
import API from "./Api";
import IdleVue from "idle-vue";

window.eventBus = new Vue();
const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 300000 // 5 Minutes
});

Vue.use(VueAxios, axiosInstance);
Vue.use(Notifications);
Vue.use(Loading);
Vue.use(VTooltip);
Vue.use(VueClipboard);
Vue.component("vue-select", Select2);
Vue.use(ClientTable, {}, false, 'bootstrap3', 'default');

var consoleHolder = console;
function debug(bool){
  if(!bool) {
    for (var key in console) {
      if (Object.prototype.hasOwnProperty.call(console, key)) {
        console[key] = function () {};
      }
    }
  }
}
debug(true);

Vue.filter('toDecimal', (value) => {
  let str = value.toString()
  return `${str.slice(0, -2)}.${str.slice(-2)}`
})

Vue.prototype.$loader = loader;
Vue.prototype.$api = API;
Vue.prototype.$numeral = number;
Vue.prototype.$currency = currency;
Vue.prototype.$download = $download;
// Vue.prototype.$copy = copy;
Vue.prototype.$copyClip = copyClip;
Vue.prototype.$applyTable = applyTable;
Vue.prototype.$ = jquery;
Vue.prototype.$encrypt = encrypt;
Vue.prototype.$decrypt = decrypt;
Vue.prototype.$paginateTable = paginateTable;

Vue.config.productionTip = false;

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start();
  }
  next();
});

router.afterEach(() => {
  NProgress.done();
})

/* eslint-disable no-new */
new Vue({
  el: "#app",
  data() {
    return {
      active: 1
    };
  },
  onIdle() {
    if (localStorage.idle !== false) {
      this.active = 0;
    }
  },
  onActive() {
    this.active = 1;
  },
  router,
  store,
  render(createElement) {
    return createElement(App, {
      props: {
        active: this.active
      }
    })
  }
});
